import { render, staticRenderFns } from "./TaskNewFormFrProject.vue?vue&type=template&id=2632f9fd&"
import script from "./TaskNewFormFrProject.vue?vue&type=script&lang=js&"
export * from "./TaskNewFormFrProject.vue?vue&type=script&lang=js&"
import style0 from "./TaskNewFormFrProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports